import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../components/queryClient';
import { useFleet } from '../hooks/useFleet';
import { useHasPermission } from '../hooks/useHasPermission';
import { Device, Fleet } from '../interfaces';
import { DevicesService } from '../services';

export const useDevices = () => {
  const fleet = useFleet();
  const queryKey = ['devices', fleet.id];
  const hasPermission = useHasPermission('devices:read:list');

  const queryFn = () => DevicesService.getAll();

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!fleet.id && hasPermission,
  });
};

export const useDevice = (id: Device['id']) => {
  const fleet = useFleet();
  const queryKey = ['devices', fleet.id, id];

  const queryFn = () => DevicesService.get(id);

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!fleet.id,
  });
};

export const useDeviceFiles = (id: Device['id']) => {
  const fleet = useFleet();
  const queryKey = ['deviceFiles', fleet.id, id];

  const queryFn = () => DevicesService.getDeviceFiles(id);

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!fleet.id && !!id,
  });
};

export const useDeviceHwVersions = () => {
  const fleet = useFleet();
  const queryKey = ['deviceHwVersions'];
  const hasPermission = useHasPermission('devices:read:list');

  const queryFn = () => DevicesService.getDeviceHwVersions();

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!fleet.id && hasPermission,
  });
};

export const refreshDevices = (fleetId: Fleet['id']) => {
  // Make sure we refetch the event in the background, WHEN NEEDED - but display
  // the cached data in the meantime, instantenously
  queryClient.invalidateQueries(['event', fleetId]);
};

export const refreshDeviceHwVersions = () => {
  queryClient.invalidateQueries(['deviceHwVersions']);
};
